import React from 'react';
import CenterModalWindow from '../../layout/ReusableComponent/CenterModalWindow/CenterModalWindow';
import '../../layout/ReusableComponent/CenterModalWindow/CenterModalWindow.css';

export default function StorageBoxMoveCopyModal({
  isOpen,
  onClose,
  itemName,
  destinationName,
  sameFolder,
  busy = false,
  onMove,
  onCopy,
}) {
  const dest = destinationName || 'this folder';

  return (
    <CenterModalWindow
      isOpen={isOpen}
      onClose={onClose}
      width="min(440px, calc(100vw - 32px))"
      height="auto"
      contentStyle={{ height: 'auto' }}
      contentClassName="sb-move-copy-modal"
    >
      <div className="sb-move-copy-modal__body" data-modal-scroll-port>
        <h3 className="sb-move-copy-modal__title">Move or copy?</h3>
        <p className="sb-move-copy-modal__desc">
          {sameFolder
            ? `Copy “${itemName}” here? The original will stay in this folder.`
            : `“${itemName}” — move it to “${dest}” (removed from the current folder) or copy it there (original stays).`}
        </p>
        <div className="sb-move-copy-modal__actions">
          <button type="button" className="sb-secondary-btn" onClick={onClose} disabled={busy}>
            Cancel
          </button>
          <button type="button" className="sb-secondary-btn" onClick={onCopy} disabled={busy}>
            {busy ? 'Please wait…' : 'Copy'}
          </button>
          {!sameFolder ? (
            <button type="button" className="sb-primary-btn" onClick={onMove} disabled={busy}>
              {busy ? 'Please wait…' : 'Move'}
            </button>
          ) : null}
        </div>
      </div>
    </CenterModalWindow>
  );
}
